import { render, staticRenderFns } from "./dispatchWhiteControl.vue?vue&type=template&id=0c8c53b2&scoped=true&"
import script from "./dispatchWhiteControl.vue?vue&type=script&lang=js&"
export * from "./dispatchWhiteControl.vue?vue&type=script&lang=js&"
import style0 from "./dispatchWhiteControl.vue?vue&type=style&index=0&id=0c8c53b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c53b2",
  null
  
)

export default component.exports